<template>
  <v-card style="height: calc(100vh - 110px)" class="ma-0 pa-0">
    <h4 id="titulo">Detalhes do fornecedor</h4>

    <div style="height: 47.4%" class="pl-1">
      <MovimentacoesEstoque
        :class="{}"
        :filtros="{
          grupos: Number(grupoCompra) > 0 ? [grupoCompra] : [],
          filiais: Number(filialCompra) > 0 ? [filialCompra] : [],
          fornecedores: idFornecedorSelecionado ? [idFornecedorSelecionado] : [],
          grupo_analise_fornecedores: getFornecedor.grupo_analise_fornecedores || false,
          atualizar_tela_compra_count_global: atualizar_tela_compra_count_global,
        }"
      />
    </div>

    <v-divider />

    <ChatStatusPerdaDeVendaPorRuptura
      :tela-compra="true" style="height: 47.4%"
      tela_compra
      :filtros="{
        grupos: Number(grupoCompra) > 0 ? [grupoCompra] : [],
        filiais: Number(filialCompra) > 0 ? [filialCompra] : [],
        fora_de_linha: false,
        inativo_revenda: false,
        compradores: [],
        segmentos: [],
        fornecedores: idFornecedorSelecionado ? [idFornecedorSelecionado] : [],
        grupo_analise_fornecedores: getFornecedor.grupo_analise_fornecedores || false,
        atualizar_tela_compra_count_global: atualizar_tela_compra_count_global,
      }"
     />
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import ChartDetalheFornecedorVendas from "./ChartDetalheFornecedorVendas";
import ChatStatusPerdaDeVendaPorRuptura from "../indicadores/PerdaVendaPorRupturas/Grafico.vue";
import MovimentacoesEstoque from "@/components/compra/ProdutosGerais/Indicadores/MovimentacaoEstoque.vue";

export default {
  name: "DetalhesFornecedor",
  components: {
    MovimentacoesEstoque,
    ChartDetalheFornecedorVendas,
    ChatStatusPerdaDeVendaPorRuptura,
  },
  computed: {
    ...mapGetters({
      grupoCompra: "usuario/getGrupoCompras",
      filialCompra: "usuario/getFilialCompras",
      getFornecedor: "fornecedor/getFornecedor",
      atualizar_tela_compra_count_global: "tabela_compra/getAtualizarTelaCompraCount",
    }),
    idFornecedorSelecionado() {
      return this.getFornecedor.id || Number(sessionStorage.getItem("idFornecedor")) || null;
    },
  },
  watch: {
    getFornecedor: {
      immediate: true,
      deep: true,
      handler(valor) {
        if (valor.id) sessionStorage.setItem("idFornecedor", valor.id);
      },
    },
  },
};
</script>

<style scoped>
#titulo {
  padding-top: 10px;
  padding-left: 10px;
}
</style>
